import React, { useContext } from 'react'
import Hero from './components/Hero'
import VideoInfo from './components/VideoInfo'
import ScrollContainer from '../../baseComponents/ScrollContainer'
import News from './components/News'

import { SettingsContext } from '../../providers/Settings'
import { getLocal } from './locals'

import './index.css'

const Vtuber = props => {
  const context = useContext(SettingsContext)
    , { lang } = context
  return <ScrollContainer>
    <div className='vtuber' data-scroll-section>
      <Hero lang={lang} getLocal={getLocal} />
      <VideoInfo />
      <News lang={lang} getLocal={getLocal} />
    </div>
  </ScrollContainer>
}

export default Vtuber